import { FC } from "react"
import './footer.css'
import { CategoryIcon } from "../MenuIcons/CategoryIcon"
import { OptionIcon } from "../MenuIcons/Options"
import { useNavigate, useParams } from "react-router-dom"
import { BasketIcon } from "../MenuIcons/Basket"
import { ProductIcon } from "../MenuIcons/Product"

const Footer: FC<any> = () => {

    const navigate = useNavigate()
    const { pluginspace_id } = useParams()

    return (
        <div className="footerContent">
            <div className="footer">
                <div className="footerOption">
                    <OptionIcon />
                    <span>Opçoes</span>
                </div>
                <div className="footerOption">
                    <ProductIcon action={() => navigate(`/${pluginspace_id}/category`)} />
                    <span>Produtos</span>
                </div>
                <div className="footerOption">
                    <BasketIcon action={() => navigate(`/${pluginspace_id}/new_cart`)} />
                    <span>Cesta</span>
                </div>
            </div>
        </div>
    )

}

export { Footer }